import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, UntypedFormControl, FormGroupDirective, NgForm, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {ShareMapService} from '../share-map.service';

export interface Type {
  value: string;
  viewValue: string;
}

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-admin-layer-download',
  templateUrl: './admin-layer-download.component.html',
  styleUrls: ['./admin-layer-download.component.css']
})
export class AdminLayerDownloadComponent implements OnInit {

  outputExt = 'kml';

  emailFormControl : UntypedFormGroup;
  matcher = new MyErrorStateMatcher();
  emailHide:boolean;
  layerId: any;
  token: any;

  constructor(private ShareMapService:ShareMapService,
    private formBuilder:UntypedFormBuilder,
    public dialogRef: MatDialogRef<AdminLayerDownloadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
        this.emailHide = data.emailHide
        this.layerId =data.layerid
        this.token= data.token
    
  }

  ngOnInit() {

    this.emailFormControl = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]] 
    });
    }
  
  closeexport(){
    this.dialogRef.close();
  }
  exportType: Type[] = [
    {value: 'kml', viewValue: 'KML'},
    {value: 'shp', viewValue: 'SHP'}
  ];
  onExportLayer(){//out,layerid,token
    this.ShareMapService.downloadGlobalFile(this.layerId,this.outputExt,this.token);
  }
  get p(){return this.emailFormControl.controls }
  onSubscribe(){ 
   this.ShareMapService.addSubscribers(this.layerId,this.p.email.value,this.outputExt).subscribe(data=>{
    if(data.http_code==200){
      this.dialogRef.close(true);
    }

 });

  }

}
